
export default function NotFound(){
    return (
        <div>
            <h3>Not Found 404</h3>
        </div>
    )
}